import type { CreditInfo, CreditTransaction, Product } from '@/types/domain'
import { http } from '@/platform/http'

export const creditApi = {
  info: () => http.get<CreditInfo>('/credit/info', { toastError: false }),
  transactions: (params: Record<string, unknown>) => http.get<{ list: CreditTransaction[], total: number }>('/credit/transactions', { params, toastError: false }),
  products: () => http.get<Product[]>('/product/type/credits', { toastError: false }),
  validateRedeemCode: (code: string) => http.get<{ available: boolean, unavailableReason?: string, type?: string, value?: number, productName?: string }>('/redeem-code/validate', { params: { code }, toastError: false }),
  redeemCode: (code: string) => http.post<{ success: boolean, message?: string }>('/redeem-code/redeem', { code }),
}
